import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
import { cn } from '../../lib/utils';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  children: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  noPadding?: boolean;
}
export function Modal({
  isOpen,
  onClose,
  title,
  description,
  children,
  maxWidth = 'md',
  noPadding = false
}: ModalProps) {
  const maxWidths = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl'
  };
  return <AnimatePresence data-id="element-273" data-mp="3vjsoxtcfyp81">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 z-50 bg-brand-900/60 backdrop-blur-sm" data-id="element-274" data-mp="3vmey1xezdcsd" />
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none" data-id="element-275" data-mp="2i363i6fr7xav">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} role="dialog" aria-modal="true" aria-labelledby={title ? 'modal-title' : undefined} className={cn('w-full max-h-[90vh] overflow-hidden rounded-xl bg-white shadow-xl pointer-events-auto flex flex-col', maxWidths[maxWidth])} data-id="element-276" data-mp="2n326q3gmnkpd">
              {(title || description) && <div className="flex items-start justify-between border-b border-brand-700 bg-brand-500 px-6 py-4 text-white" data-id="element-277" data-mp="1kf5snicr1mr1">
                  <div data-id="element-278" data-mp="3ibvx4a1q86l2">
                    {title && <h2 id="modal-title" className="text-lg font-bold" data-id="element-279" data-mp="3iab26jbi2lmo">
                        {title}
                      </h2>}
                    {description && <p className="mt-1 text-sm text-brand-100" data-id="element-280" data-mp="38fau1u99p5jv">
                        {description}
                      </p>}
                  </div>
                  <button type="button" onClick={onClose} aria-label="Close dialog" className="rounded-md p-1 text-brand-100 transition-colors hover:bg-white/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-300" data-id="element-281" data-mp="4wpujcocls2h">
                    <X className="h-5 w-5" data-id="element-282" data-mp="2klsqelaw18ol" />
                  </button>
                </div>}
              <div className={cn('overflow-y-auto', noPadding ? '' : 'p-6')} data-id="element-283" data-mp="w4hrxk64iy4n">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}